import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AccountService } from "src/app/services/account.service";
import { ScrBaseComponent } from "../../base.component";
import { ScrEnvironment } from 'src/environments/environment';
import { Config, ConfigService } from "src/app/services/config.service";

@Component({
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent extends ScrBaseComponent {
  verified = false;
  invalid = false;
  expired = false;
  pending = true;
  nonce = '';

  config?: Config;

  constructor(
    public environment: ScrEnvironment,
    public configService: ConfigService,
    private route: ActivatedRoute,
    private accountService: AccountService) {
    super();

    this.configService.getConfig().subscribe(config => this.config = config);

    this.route.params.subscribe(params => {
      this.nonce = params.nonce;

      if (this.nonce)
        this.accountService.verifyAccount(this.nonce).subscribe({
          next: () => {
            this.pending = false;
            this.verified = true;
          },
          error: error => {
            this.pending = false;

            // try to parse the response body and pull the message code.
            if (typeof error.error === 'string') {
              try {
                const messageBody = JSON.parse(error.error);
                this.invalid = (messageBody.messages[0].code === '1115');
                this.expired = (messageBody.messages[0].code === '1116');
              }
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              catch (e) {
                this.log.warn(`unable to parse error ${JSON.stringify(error.error)}`);
              }
            }
            else {
              this.invalid = (error.error.messages[0].code === '1115');
              this.expired = (error.error.messages[0].code === '1116');
            }
          }
        });
    });
  }

  resendVerification() {
    this.observe(this.accountService.resendVerification(this.nonce), () => {
      this.displayLocalizedSuccess('scr.verification.sent');
      return false;
    });
  }
}
